import Raven from 'raven-js'
import * as log from 'loglevel'

import apollo from '@/graphql'
import router from '@/router'
import { Message, MessageBox } from 'element-ui'

import ExchangeMFACode from '@/graphql/auth/ExchangeMFACode.gql'
import GetMFAQrCode from '@/graphql/auth/GetMFAQrCode.gql'

function completeMFAEnrollment({ commit, dispatch }, { mfaCode }) {
  apollo.defaultClient.mutate({
    mutation: ExchangeMFACode,
    variables: { mfaCode, rememberMe: false },
  }).then(({ data: { exchangeMFACode: { success, user, iat, exp } } }) => {
    if (success === true) {
      commit('Auth/setUser', Object.assign(user, { iat, exp, type: 'LOGIN' }), { root: true })
      commit('Auth/setStatus', 'LOGIN_SUCCESS', { root: true })
      MessageBox({
        title: 'MFA Enrollment Complete',
        confirmButtonText: 'OK',
        message: 'You have successfully enrolled in multi-factor authentication. '
                 + 'From now on, you will be prompted to enter a verification code '
                 + 'each time you log in.',
        center: false,
      })
      router.push('/')
      return
    }
    Message({
      message: 'Incorrect code. Please try again.',
      type: 'error',
    })
  }).catch((err) => {
    Raven.captureException(err)
    Message({
      message: 'Your enrollment session has expired. Please try again.',
      type: 'error',
    })
    dispatch('Auth/clearStatus', null, { root: true })
    dispatch('Auth/logout', null, { root: true })
  })
}

function loadQrCode({ commit, dispatch }) {
  log.debug('Attempting to load enrollment QR code')
  apollo.defaultClient.query({
    query: GetMFAQrCode,
  }).then(({ data: { getMFAQrCode } }) => {
    if (getMFAQrCode) {
      log.debug('Successfully loaded QR code')
      commit('setQrCode', getMFAQrCode)
      return
    }
    Message({
      message: 'An unexpected error has occurred. Please try logging in again to restart enrollment.',
      type: 'error',
    })
    dispatch('Auth/logout', null, { root: true })
  }).catch((err) => {
    log.error('Unexpected error loading QR code', err)
    Raven.captureException(err)
    Message({
      message: 'An unexpected error has occurred. Please try logging in again to restart enrollment.',
      type: 'error',
    })
    dispatch('Auth/logout', null, { root: true })
    commit('Auth/setLoading', false, { root: true })
  })
}

export default {
  completeMFAEnrollment,
  loadQrCode,
}



// WEBPACK FOOTER //
// ./src/store/modules/mfa/mfa.actions.js